module.exports = __webpack_public_path__ + "static/img/nikon.6de5fb2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nikon.jpg
// module id = 297
// module chunks = 0